import React  from "react";
import {  Box   , Typography , LinearProgress } from "@mui/material";
import useProgress from "../../../shared/progressBar";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DataModal from '../../../shared/DynamicModal'
import CustomerFileTable from "./CustomerFileTable";
export const UploadModal = ({   customerFileData  , failedCustomers , ...props }) => {
 
  const Modalstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 544,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: '5px',
  };
   
  const progress = useProgress()





 const handleClickOpenTable = () => {
  props.setOpenTable(true)
  //setOpen(false)
 }
  return (
    <> 
    <DataModal
      changeWidth="50%"
onClose={props.handleClose}
open={props.open}
discardChanges={props.handleClose}
HeadrTitle="Customer File"
ButtonTitle="Continue Uploading"
disabled = {!customerFileData?.valid}
saveChanges={handleClickOpenTable}
    >
<Box>

<Box sx={{ width: '100%' }}>
<Typography sx={{margin:"0 0 10px 0"}}>{props.fileProps.name} ({props.fileProps.size})</Typography>


<Box sx={{ display: 'flex', alignItems: 'center' }}>
<UploadFileIcon fontSize="large"/>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" value={progress}  />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">({progress}%)</Typography>
      </Box>
      
    </Box>

    </Box>
          </Box>
    </DataModal>
    
   {/* <NewCustomerFileTable customerData={customerFileData.data} setOpenTable={setOpenTable} openTable={openTable}/> */}
 {props.openTable &&  <CustomerFileTable 
 {...props}
 customerFileData={customerFileData?.data}
 failedCustomers={failedCustomers}
 />
}
    
 
  </>
   
  );
};
